import { GET_ZONA_DETALLE, ADD_PRODUCTO_CAJA_DE_ZONA, MODIFY_PRODUCTO_CAJA_DE_ZONA, DELETE_PRODUCTO_CAJA_DE_ZONA } from '../constants/action_types';

const initialState = {
    isLoading: true,
    productosCaja: []
};

export default function (state = initialState, action) {

    switch (action.type) {
        case GET_ZONA_DETALLE + "_SUCCESS":

            return {
                isLoading: false,
                productosCaja: action.payload.data.productosCaja
            };


        case ADD_PRODUCTO_CAJA_DE_ZONA:

            const newArr = [...state.productosCaja, action.payload]

            return {
                isLoading: false,
                productosCaja: newArr
            };

        case MODIFY_PRODUCTO_CAJA_DE_ZONA:

            return {
                isLoading: false,
                productosCaja: state.productosCaja.map((productos) => {
                    if (productos.id !== action.payload.id) return productos;
                    else return action.payload;
                })
            };

        case DELETE_PRODUCTO_CAJA_DE_ZONA:

            return {
                isLoading: false,
                productosCaja: state.productosCaja.filter(productos => productos.id !== action.payload.id)
            };

        default:

            return state;
    }

}